// Import external dependencies
import '@babel/polyfill';
import 'jquery';
import 'bootstrap/dist/js/bootstrap';
import 'parsleyjs';
import 'select2';
import 'iframe-resizer';
import select2 from 'v-select2-component';
import Swiper from 'swiper';
import * as Sentry from '@sentry/vue';
import {Integrations} from '@sentry/tracing';

//Import Router
import Router from './util/Router';
//Import local dependencies
import common from './routes/common';
import contact from './routes/contact';
import VueScrollTo from 'vue-scrollto';
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueRouter from 'vue-router';
import vSelect from 'vue-select';
import ZoomOnHover from './components/zoom-on-hover-modified';
import catalogComponent from './components/catalog/catalogComponent';
import productComponent from './components/product/productComponent';
import checkoutComponent from './components/checkout/checkoutComponent';
import oneClickCheckout from './components/checkout/oneClickCheckout';
import cartComponent from './components/cart/cart';
import headerAutoSearch from './components/headerAutoSearch';
import SocialSharing from 'vue-social-sharing';
import profileComponent from './components/account/profile/index';
import infiniteScroll from 'vue-infinite-scroll';
import Skeleton from 'vue-loading-skeleton';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';

/**
 * NOTE: !!!!!DON'T FORGET ADD NEW COMPONENTS TO WEBPACK PURGECSS!!!!!!
 */
import Dialog from 'element-ui/lib/dialog';
import Loading from 'element-ui/lib/loading';
import MessageBox from 'element-ui/lib/message-box';
import Message from 'element-ui/lib/message';
import DatePicker from 'element-ui/lib/date-picker';
import Notification from 'element-ui/lib/notification';
import store from './store/';
import ErrorHandler from './mixins/ErrorHandler';
import giftCertificateComponent from './components/account/gift_certificate/giftCertificateComponent';
import flexCatalogComponent from './components/catalog/flexCatalogComponent';

require('./bootstrap');
require('./components/global');
require('@fancyapps/fancybox');
require('jquery-lazy');
require('waypoints/lib/jquery.waypoints');
require('waypoints/lib/shortcuts/sticky');
require('sticky-kit/dist/sticky-kit');

Sentry.init({
  Vue: Vue,
  logErrors: true,
  environment: window.environment || 'local',
  dsn: 'https://c7fd7f0b081941e688b6e3167f0ed997@sentry.wmt.dev/5',
  integrations: [
    new Integrations.BrowserTracing(),
  ],
  tracesSampleRate: 0.5,
  tracingOptions: {
    trackComponents: true,
  },
});

if (window.user) {
  Sentry.setUser(user.content)
}

window.Swiper = Swiper;

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  //Contact forms
  contact,
});

// Load Events
jQuery(document).ready(() => routes.loadAllEvents());

Vue.prototype.$ELEMENT = {zIndex: 10000};

// Setup ENG language for Element-UI
locale.use(lang);

Vue.use(VueScrollTo, {
  offset: -150,
});
Vue.mixin(ErrorHandler);
Vue.use(VueRouter);
Vue.use(Dialog);
Vue.use(Skeleton);
Vue.use(DatePicker);
Vue.use(VeeValidate);
Vue.use(SocialSharing);
Vue.use(infiniteScroll);
Vue.use(ZoomOnHover);
Vue.use(require('vue-moment'));
Vue.component('v-select', vSelect);
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
Vue.prototype.$notify = Notification;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.component('select2', select2);
Vue.component('product-component', productComponent);
Vue.component('checkout-component', checkoutComponent);
Vue.component('catalog-component', catalogComponent);
Vue.component(oneClickCheckout.name, oneClickCheckout);
Vue.component('flex-catalog-component', flexCatalogComponent);
Vue.component('cart', cartComponent);
Vue.component('profile', profileComponent);
Vue.component('gift-form-component', giftCertificateComponent);
Vue.component('header-auto-search', headerAutoSearch);

const router = new VueRouter({
  mode: 'history',
  stringifyQuery: (q) => {
    return qs.stringify(q,
      {encode: false, skipNulls: true, addQueryPrefix: true});
  },
  parseQuery: (q) => {
    return qs.parse(q, {parseArrays: false});
  },
});

new Vue({
  el: '#wmt-app',
  store,
  router,
  created() {
    this.$store.dispatch('checkout/fetchCheckoutConfig');
  },
});
